import Cookies from 'js-cookie'
import Vue from "vue"
import {getVideoClassifyList,editVideoClassify,addVideoClassify,add_video,edit_video,del_class_video} from "@/api/api"
let edit_video_success_fn,video_form = {
	images:[],
	section:[]
}

export default {
	state: {
		show_edit_video:false,
		video_form,
		showEditVideoClassify:false,
		VideoClassifyStore:[],
		VideoClassifyForm:{
			title:'',
			img_url:'',
			parent_id:'',
			success:""
		}
	},
	mutations: {
		change_show_edit_video(state){
			state.show_edit_video = !state.show_edit_video
		},
		add_section(state,e){
			console.log(e)
			if(e){
  			//有E则为子节点
  			e.data.children.push({
          label:`${e.data.key}-${e.data.children.length+1}`,
          level:2,
          title:'',
          url:'',
          images:'',
          key:`${e.data.key}-${e.data.children.length+1}`
        })
  		}
  		else{
  			state.video_form.section.push({
          label:`第${state.video_form.section.length+1}章`,
          level:1,
          title:'',
          price:'',
          key:`${state.video_form.section.length+1}`,
          children:[]
        })
  		}
  	},
  	reload_video_form(state,e){
  		Vue.set(state,'video_form',JSON.parse(JSON.stringify(state.video_form)))
  	},
  	edit_video_success(state){
  		let data = JSON.parse(JSON.stringify(state.video_form));
  		console.log(data);
  		if(data.id){
  			edit_video(data,res=>{
  				window.vuevm.$message({
  					type:'success',
  					message:res.data.msg
  				})
  				if(edit_video_success_fn){
  					edit_video_success_fn();
  				}
  				state.show_edit_video = false;
  				state.video_form = video_form;
  			})
  		}
  		else{
  			add_video(data,res=>{
  				window.vuevm.$message({
  					type:'success',
  					message:res.data.msg
  				})
  				state.show_edit_video = false;
  				state.video_form = video_form;
  			})
  		}
  	},
  	editGoods(state,e){
     this.commit("getVideoClassify")
     if(e.item == "add"){
      state.video_form = video_form;
    }
    else{
     e.item = JSON.parse(JSON.stringify(e.item))
     e.item.all_price = e.item.all_price == 1;
     e.item.catalog_price = e.item.catalog_price == 1;
     e.item.images = [e.item.images];
     e.item.classify = e.item.cid.split(",")
     state.video_form = e.item;
   }
   edit_video_success_fn = e.fn;
   state.show_edit_video = true;
 },
 del_section(state,e){
  console.log(e)
  if(e.data.level == 1){
   if(e.data.children.length>0){
    window.vuevm.$confirm(`此章节包含了${e.data.children.length}个视频,确认删除?`, '提示', {
     confirmButtonText: '确定',
     cancelButtonText: '取消',
     type: 'warning'
   }).then(() => {
     state.video_form.section.splice(e.data.key-1,1)
   }).catch(() => {       
   });
 }
 else{
  state.video_form.section.splice(e.data.key-1,1)
}
}
else if(e.data.level == 2){
 let index = e.data.key.split("-");
 state.video_form.section[index[0]-1].children.splice(index[1]-1,1)
}
},
del_video(state,e){
  edit_video_success_fn = e.fn;
  window.vuevm.$confirm(`确认删除?`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    del_class_video({id:e.item.id},res=>{
      window.vuevm.$message({
        type:'success',
        message:res.data.msg
      })
      edit_video_success_fn();
    })
  }).catch(() => {       
  });
},
editVideoClassify(state,paramete){
  this.commit('getVideoClassify')
  if(paramete.action=="add"){
   state.VideoClassifyForm={
    title:'',
    img_url:'',
    parent_id:'',
    success:""
  }
}
else{
 state.VideoClassifyForm={
  classify_id:paramete.action.id,
  title:paramete.action.title,
  img_url:paramete.action.img_url,
  parent_id:paramete.action.parent_id
}
console.log(paramete)
}
state.VideoClassifyForm.parent_id = paramete.pid;
state.VideoClassifyForm.success = paramete.success;
state.showEditVideoClassify = true

},
hideeditVideoClassify(state){
  state.showEditVideoClassify=false
},
editVideoClassifySuccess(state){
  console.log(state.VideoClassifyForm)
  if(state.VideoClassifyForm.classify_id){
   editVideoClassify(state.VideoClassifyForm,window.vuevm,res=>{
    window.vuevm.$message({
     type:'success',
     message:res.data.msg
   })
    state.VideoClassifyForm.success()
    state.showEditVideoClassify = false;
  })

 }
 else{
   addVideoClassify(state.VideoClassifyForm,window.vuevm,res=>{
    window.vuevm.$message({
     type:'success',
     message:res.data.msg
   })
    state.VideoClassifyForm.success()
    state.showEditVideoClassify = false;
  })
 }

			// editVideoClassify({})
		},
		getVideoClassify(state,fn){
			getVideoClassifyList(window.vm,res=>{
				state.VideoClassifyStore = res.data.list;
				if(fn){
					fn(res.data.list)
				}
			})
		},
	},
}


// WEBPACK FOOTER //
// ./src/store/modules/video.js